var desktopPlacement = true;

jQuery(document).ready(commonInit);

function commonInit(){
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupMobileMenu();
	setupColumns();
	setupSearch();	
	setupScrollDetect();
	setupLanguageToggleMove();
	moveLanguageToggle();
}

function setupSearch() {
	jQuery('.search-button').on('click', function(e){
		
		var html = jQuery('html');
		var searchButton = jQuery(this);
		var isHeader = searchButton.parents('header').length;
		
		if(!html.hasClass('search-open')) {
		
			e.preventDefault();
			
			if(isHeader) {
				html.addClass('search-open-header search-open');
				jQuery('#search-header-desktop').focus();
			} else {
				html.addClass('search-open-footer search-open');
				jQuery('#search-footer').focus();
			}
			
		}
		
	});
	
	jQuery('.search-container form').on('click', function(e){
				
		e.stopPropagation();
		
	});
	
	jQuery('html').on('click', function(e){
		jQuery('html').removeClass('search-open-header search-open-footer search-open');
	});
	
}

function setupMobileMenu(){
	
	jQuery("#mobile-nav").mmenu({
		"slidingSubmenus": false,
		"offCanvas": {
			"position": "top"
		}
	}, {

		classNames: {
			selected: "current-menu-item",
			fixedElements: {
				
				fixed: "mobile-sticky"
				
			}
			
		}
		
	});
	
	jQuery(".language a.toggle").on("click", function(){
		
		jQuery(".language-dropdown").toggleClass("hide");
		
	});
	
}

function setupColumns(){
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).length;
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

function setupLanguageToggleMove() {
	
	jQuery(window).on("resize", moveLanguageToggle);
	
}

function moveLanguageToggle() {
	
	var windowWidth = jQuery(window).width();
	
	if(windowWidth <= 1008 && desktopPlacement) {
		
		jQuery(".country-selector").appendTo("header.mobile .language-dropdown");
		desktopPlacement = false;
		
	} else if(windowWidth > 1008 && !desktopPlacement) {
		
		jQuery(".country-selector").insertAfter(jQuery("header#desktop-header .search-container"));
		desktopPlacement = true;
		
	}
	
}


//usage: var first = getUrlVars()['id'];
function getUrlVars(){
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}
window.getUrlVars = getUrlVars;

function setCookie(cname, cvalue, exdays){
	 
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    
}
window.setCookie = setCookie;

function getCookie(cname){
	
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    
    for(var i = 0; i <ca.length; i++){
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
     
    return ""; 
    
}
window.getCookie = getCookie;

function setupScrollDetect(){
	
	jQuery(window).on('scroll', function(){
		
		var offset = jQuery(window).scrollTop();
		var html = jQuery('html');
		
		if(offset > 220) {
			html.addClass('not-top');
		} else {
			html.removeClass('not-top');
		}
		
	});
	
}
